import React, { useEffect, useState } from "react";
import apiClient from "../BaseUrl/apiClient.js";
import SriyanshCardHeader from "../components/CardHeader";

import {
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import TokenService from "../service/TokenService";
import ToasterAlerts from "../components/ToasterAlerts";
//import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { BoxStyle } from "../constantVaribles/constatanvariable";
import { useNavigate } from "react-router-dom";
import WhatsAppButton from "../whatsapp/WhatsAppButton.js";

const EmailForm = () => {
  //const [email, setEmail] = useState("amitprasri@gmail.com");

  const [message, setMessage] = useState("");
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
const email = tokenServiceDetails?.emailid;

//console.log(email);


  const [error, setError] = useState("");
  const [file, setFile] = useState(null);

  const [fileSizeError, setFileSizeError] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]; // Get the selected file
    // Check if the file is selected
    if (selectedFile) {
      const maxSize = 1 * 1024 * 1024; // 5MB max file size in bytes
      if (selectedFile.size > maxSize) {
        setFileSizeError("File size exceeds 1MB.");
        setFile(null); // Reset file if size exceeds limit
      } else {
        setFileSizeError(null);
        setFile(selectedFile); // Set the file if within size limit
      }
    }
  };

  const [suggetion, setsuggetion] = useState("");
  const [suggetions, setsuggetions] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const fetchSuggestions = async () => {
    try {
      const response = await apiClient.post("/SuggestionList", {
        /* request payload if needed */
      });
      setsuggetions(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(
    () => {
      // Update state if roles change (in case roles are updated dynamically)
      if (suggetions.length > 0) {
        setsuggetion(suggetions[0].suggestionType);
      }
    },
    [suggetions],
    error
  );

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (fileSizeError && fileSizeError.length > 0) {
      alert("File Size is more then required size");
    } else {
      try {
        // Create a new FormData object
        const formData = new FormData();
        formData.append("suggestion", suggetion); // Ensure 'suggestion' is correct
        formData.append("message", message);
        formData.append("uname", uname);
        formData.append("email", email);
        
        //console.log(file);
        // Append file if it exists
        if (file) {
          formData.append("file", file);
        }
//console.log(formData);
       // Send the form data using the POST method
        const response = await apiClient.post("/sendemail", formData, {
          // headers: {
          //   "Content-Type": "multipart/form-data",  // Ensure that the correct content type is set
          // },
        });

        // Handle successful email sending
        alert("Email sent successfully!");
        //setEmail("");   // Clear email field
        setMessage(""); // Clear message field
        setFile(null);
      } catch (error) {
        // Handle error in case of failure
        alert("Failed to send email.");
        console.error("Error sending email:", error); // Log error for debugging
      }
    }
  };

  return (
    <div >
      {/* <SriyanshCardHeader Title="Help Desk Call  Arvind  -  📱 9794840488 or Amit-  📱 9450887365" /> */}

      <Card className="Formcard">
        {error && (
          <ToasterAlerts
            type="info"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )}
<div className="input-groupHeading">
Help Desk =>  Arvind  -  📱 9794840488 or Amit-  📱 9450887365

            </div>
        <div className="row" style={BoxStyle}>
          <CardContent>
            <form style={{ padding: "20px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Select
                    value={suggetion}
                    id="helpdesk"
                    onChange={(e) => setsuggetion(e.target.value)}
                    style={{ width: "100%" }}
                  >
                    {suggetions.map((Item) => (
                      <MenuItem
                        key={Item.suggestionType}
                        value={Item.suggestionType}
                      >
                        {Item.suggestionType}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Message Max 250 Characters"
                    value={message}
                    id="message"
                    onChange={(e) => {
                      const value = e?.target?.value;
                      if (`${value}`.length <= 250) setMessage(e.target.value);
                    }}
                    required
                    fullWidth
                    multiline
                    rows={4}
                  />
                </Grid>
              </Grid>

             
            </form>
          </CardContent>
          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleSubmit}
                title="Click for send Mail"
              >
                Send Mail
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Close"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
          
        </div>
        
      </Card>

      <div></div>
      <WhatsAppButton />
    </div>

    
  );
};

export default EmailForm;
